/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import "moment-timezone";
import React from "react";
import Moment from "react-moment";
import { DDD_DD_MMM_YYYY, TIME_ZONE } from "../../../../../utils/const";
export const AcceptRejectDateFormatter = (cellContent, row, rowIndex) => {
  const { acceptedRejectedDate } = row || {};
  return (
    <>
      {acceptedRejectedDate && acceptedRejectedDate !== "NA" ? (
        <Moment
          date={acceptedRejectedDate}
          format={DDD_DD_MMM_YYYY}
          tz={TIME_ZONE}
        />
      ) : (
        "-"
      )}

      <> </>
    </>
  );
};
